import httpClient from "@/services/httpClient";
import { server } from "@/services/constants";

export const getSettingMenuDetail = () => {
  return httpClient.get(server.SETTING_MENU_DETAIL_URL + `/get`);
};

export const getSMD_ById = (sgm_id) => {
  return httpClient.get(
    server.SETTING_MENU_DETAIL_URL + `/getcountbyid/${sgm_id}`,
  );
};

export const getListMenuDetailById = (sgm_id) => {
  return httpClient.get(
    server.SETTING_MENU_DETAIL_URL + `/getlismenudetailbyid/${sgm_id}`,
  );
};

export const getListMenuDetailByIdAndCompanyID = (sgm_id, company_id) => {
  return httpClient.get(
    server.SETTING_MENU_DETAIL_URL +
    `/getlismenudetailbyid_companyid/${sgm_id}/${company_id}`,
  );
};

// ⭐ ใหม่: ดึงเมนู (group + submenu) เป็น tree ตามสิทธิ์ของ user สำหรับ Menu.vue
// sgm_id = setting_group_menu_id (เก็บใน localStorage ที่ key server.AUTHORIZE_ID)
export const getMenuTree = (sgm_id, company_id, user_id) => {
  return httpClient.get(
    server.SETTING_MENU_DETAIL_URL + `/menu-tree/${sgm_id}/${company_id}`,
    { params: { user_id } },
  );
};

export const updateSettingMenuDetail = (id, data) => {
  return httpClient.put(server.SETTING_MENU_DETAIL_URL + `/${id}`, data);
};

export const createSettingMenuDetail = (data) => {
  return httpClient.post(server.SETTING_MENU_DETAIL_URL, data);
};

export const deleteSettingMenuDetail = (id) => {
  return httpClient.delete(server.SETTING_MENU_DETAIL_URL + `/${id}`);
};

// ⭐ ใหม่: ลบสิทธิ์ทั้งหมดที่ผูกกับ menu_detail_id นี้ (bulk) — เรียกก่อนลบตัว submenu
// ป้องกันแถวลอยใน tbl_setting_menu_detail ตอนลบ submenu จากหน้า Sub Menu
export const deleteSettingMenuDetailByMenuDetailId = (
  menu_detail_id,
  company_id,
) => {
  return httpClient.delete(
    server.SETTING_MENU_DETAIL_URL +
    `/by-menu-detail/${menu_detail_id}/${company_id}`,
  );
};